import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .mwh{color:var(--vscode-editorWhitespace-foreground)!important;position:absolute}";
n(css,{});
export { css, css as default };
